export enum OrigenCertificadoEnum {
Chilesystems = 1,
SimpleAPI = 2,
Simplefactura = 3,
Externo = 4
 }